import { FC } from 'react';
import { EmailTemplate } from '../../types/emailTemplates';
import { EmailTemplateCard } from '../EmailTemplateCard';
import { EmailTemplateTable } from '../EmailTemplateTable';
import { VIEW_MODES, ViewMode } from '@/components/ViewToggle/ViewToggle';

type EmailTemplateListContentProps = {
  viewMode: ViewMode;
  items: EmailTemplate[];
  onEdit: (templateId: string) => void;
  onRequestDelete: (template: EmailTemplate) => void;
};

export const EmailTemplateListContent: FC<EmailTemplateListContentProps> = ({ viewMode, items, onEdit, onRequestDelete }) => {
  if (viewMode === VIEW_MODES.TABLE) {
    return (
      <div className='overflow-x-auto rounded-2xl border border-secondary-border bg-white'>
        <EmailTemplateTable items={items} onEdit={onEdit} onRequestDelete={onRequestDelete} />
      </div>
    );
  }

  return (
    <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-4'>
      {items.map((item) => (
        <EmailTemplateCard key={item.id} template={item} onEdit={onEdit} onRequestDelete={onRequestDelete} />
      ))}
    </div>
  );
};
